// Body composition for PUT /vista-admin/organizations/:orgId.
//
// Extracted from OrgDetail.jsx's EditOrgModal so the change-detection +
// integer coercion is unit-testable without React component machinery
// (PR #497 review nit). The worker accepts boolean | 0 | 1 for the
// dedup flag; we send 0/1 to match the column type and keep the audit
// `from`/`to` values numeric.

export function composeOrgEditBody(existing, current) {
  const body = {};
  if (current.name !== existing.name) body.name = current.name;
  if (current.slug !== existing.slug) body.slug = current.slug;
  if (Boolean(current.dedup) !== Boolean(existing.cross_agent_dedup_enabled)) {
    body.cross_agent_dedup_enabled = current.dedup ? 1 : 0;
  }
  // S14-18: per-org Network Services feature flag (same 0/1 contract).
  if (Boolean(current.networkServices) !== Boolean(existing.network_services_enabled)) {
    body.network_services_enabled = current.networkServices ? 1 : 0;
  }
  return body;
}
